export class Country
{
  public pais?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
  public language?: string;
  public isoa3?: string;
}
